// src/components/AdminDashboard.jsx
import React from "react";
import TopNavbar from "../../components/Gnavbar";
import BottomNavbar from "../../components/BottomNavbar";
import { NavLink } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

// ✅ Import all icons used in the component
import {
  FaEdit,
  FaImage,
  FaLink,
  FaSlidersH,
  FaMapMarkerAlt,
  FaUserCircle,
  FaFileContract,
  FaTrophy,
  FaComments,
  FaBox,
  FaCogs,
} from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

const EditWebsite = () => {
  const { t } = useLanguage();

  const buttonVariants: any = {
    primary:
      "bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 shadow-lg hover:shadow-xl transform hover:scale-105",
    secondary:
      "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-lg hover:shadow-xl transform hover:scale-105",
    accent:
      "bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 shadow-lg hover:shadow-xl transform hover:scale-105",
    success:
      "bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 shadow-lg hover:shadow-xl transform hover:scale-105",
    warning:
      "bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 shadow-lg hover:shadow-xl transform hover:scale-105",
    info: "bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 shadow-lg hover:shadow-xl transform hover:scale-105",
  };

  const ButtonCard = ({
    to,
    variant,
    icon: Icon,
    children,
    className = "",
  }: any) => (
    <NavLink
      to={to}
      className={`
        relative overflow-hidden rounded-xl text-white font-medium
         px-2 py-3 text-center transition-all duration-300 ease-in-out
        flex items-center justify-center space-x-3
        ${buttonVariants[variant]}
        ${className}
        group
        
      `}
    >
      <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
      <Icon className="text-xl group-hover:rotate-12 transition-transform duration-300" />
      <span className="font-semibold tracking-wide">{children}</span>
      <div className="absolute -top-1 -right-1 w-3 h-3 bg-white bg-opacity-20 rounded-full group-hover:scale-150 transition-transform duration-300"></div>
    </NavLink>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50">
      <TopNavbar />

      <div className="container mx-auto px-4 py-8 max-w-6xl">
        {/* Back Button */}

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent mb-4">
            {t("Edit Your Business Website")}
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            {t(
              "Customize and manage all aspects of your business website with our comprehensive editing tools"
            )}
          </p>
        </div>

        {/* Main Grid */}
        <div className="space-y-4 mb-32">
          <div className="grid grid-cols-2 gap-3 sm:gap-6">
            <ButtonCard
              to="/admin/profile/edit"
              variant="primary"
              icon={FaEdit}
            >
              {t("Edit Website")}
            </ButtonCard>

            <ButtonCard
              to="/admin/website/social"
              variant="primary"
              icon={FaEdit}
            >
              {t("Edit Social Media Pages")}
            </ButtonCard>

            {/* <ButtonCard to="/website/banner" variant="secondary" icon={FaImage}>
              Edit Main Banner
            </ButtonCard> */}
            <ButtonCard
              to="/admin/website/links"
              variant="accent"
              icon={FaLink}
            >
              {t("Edit your business videos")}
            </ButtonCard>

            <ButtonCard
              to="/admin/website/images"
              variant="info"
              icon={FaSlidersH}
            >
              {t("Slider Banners")}
            </ButtonCard>

            <ButtonCard
              to="/admin/website/locations"
              variant="success"
              icon={FaMapMarkerAlt}
            >
              {t("Branch Locations")}
            </ButtonCard>

            {/* <ButtonCard
              to="/edit-profile"
              variant="secondary"
              icon={FaUserCircle}
            >
              Profile Image
            </ButtonCard> */}

            <ButtonCard
              to="/admin/website/terms"
              variant="warning"
              icon={FaFileContract}
            >
              {t("Terms & Conditions")}
            </ButtonCard>

            <ButtonCard
              to="/admin/website/stories"
              variant="accent"
              icon={FaTrophy}
            >
              {t("Success Stories")}
            </ButtonCard>
            <ButtonCard
              to="/admin/website/testimonials"
              variant="primary"
              icon={FaComments}
            >
              {t("Testimonials")}
            </ButtonCard>

            <ButtonCard
              to="/admin/website/packages"
              variant="info"
              icon={FaBox}
            >
              {t("Manage Packages")}
            </ButtonCard>
            <ButtonCard
              to="/admin/website/services"
              variant="success"
              icon={FaCogs}
            >
              {t("My Services")}
            </ButtonCard>

            <ButtonCard
              to="/admin/website/logo"
              variant="accent"
              icon={FaImage}
            >
              {t("Navbar Logo")}
            </ButtonCard>
            <ButtonCard
              to="/admin/website/newDetails"
              variant="info"
              icon={FaEdit}
            >
              {t("Edit Location Details")}
            </ButtonCard>
            <ButtonCard
              to="/admin/website/promotion"
              variant="primary"
              icon={FaImage}
            >
              {t("Add Promotion banners")}
            </ButtonCard>
          </div>
        </div>
      </div>

      <BottomNavbar />
    </div>
  );
};

export default EditWebsite;
